export const DENIED_STATUSES = ["partially_approved", "denied"];
